import React, { ReactNode } from 'react'
import styled, { css } from 'styled-components'
import CreationToolStatus from '../../../../types/status'
import CreationToolUIAnimation from '../../../../types/ui-animation'
import { StickerBlock } from '../../../blocks'
import SourcePlayer from '../../../source-player'
import SourceThumbnail from '../../../source-thumbnail'
import { CreationToolUploadSource } from '../../types'
import Loader from './loader'

const MAX_WIDTH = 460
const MAX_HEIGHT = 520
const MAX_ASPECT_RATIO = MAX_WIDTH / MAX_HEIGHT

const Container = styled.div<{ hasError: boolean }>`
    ${CreationToolUIAnimation.css(CreationToolUIAnimation.FadeIn)}
    position: relative;

    ${({ hasError }) =>
        hasError &&
        css`
            box-sizing: border-box;
            padding: 15px;
        `}
`

const Wrapper = styled.div`
    margin: 0 auto;
`

const Preview = styled(SourceThumbnail)`
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
`

type Props = {
    className?: string
    children?: ReactNode
    source: CreationToolUploadSource
}

const CreationUploadItemPreview = ({ className, source: uploadSource, children }: Props) => {
    const { error, source, edits, outputType, status } = uploadSource
    const aspectRatio = edits?.crop ? edits.crop.width / edits.crop.height : source.width / source.height
    const width = aspectRatio < MAX_ASPECT_RATIO ? Math.round(MAX_HEIGHT * aspectRatio) : MAX_WIDTH
    const isIdle = status === CreationToolStatus.Idle

    return (
        <Container
            {...{
                className,
                as: !!error || source.isTransparent ? StickerBlock : 'div',
                hasError: !!error,
            }}
        >
            {error ? (
                <>
                    <Preview source={source} />
                    {children}
                </>
            ) : (
                <Wrapper style={{ width }}>
                    <SourcePlayer
                        {...{
                            source,
                            edits,
                            outputType,
                        }}
                    >
                        {isIdle ? children : <Loader status={status} />}
                    </SourcePlayer>
                </Wrapper>
            )}
        </Container>
    )
}

export default CreationUploadItemPreview
